// Default intialize env DEV
let env = {
    clientID: 'QSniNKOWpgC0KpCXJdWDeVwQ0ndwIQ1R',
    domain: 'crawford-dev.auth0.com',
    audience: 'https://redbookapidev.crawco.com/',
    redirectUri: 'https://redbookdev.crawco.com/callback'
};

// Checking host for config selection
switch (window.location.host) {
    case 'redbookdev.crawco.com':
        env.domain = 'crawford-dev.auth0.com';
        env.audience = 'https://redbookapidev.crawco.com/';
        env.redirectUri = 'https://redbookdev.crawco.com/callback';
        break;
    case 'redbookqa.crawco.com':
        env.domain = 'crawford-dev.auth0.com';
        env.audience = 'https://redbookapiqa.crawco.com/';
        env.redirectUri = 'https://redbookqa.crawco.com/callback';
        break;
    case 'redbookuat.crawco.com':
        env.clientID = 'wYDisTBe4E7poiKnARS6gwYb03rBwm0Y';
        env.domain = 'crawford-stage.auth0.com';
        env.audience = 'https://redbookapiuat.crawco.com/';
        env.redirectUri = 'https://redbookuat.crawco.com/callback';
        break;
    case 'redbook.crawco.com':
        env.clientID = 'v5m78rbar50tbggcU28zoWnE7o5WDCba';
        env.domain = 'crawford-prod.auth0.com';
        env.audience = 'https://redbookapi.crawco.com/';
        env.redirectUri = 'https://redbook.crawco.com/callback';
        break;
};

export const environment = {
    production: false,
    authWeb: {
        clientID: env.clientID,
        domain: env.domain,
        audience: env.audience,
        scope: 'openid profile email',
        responseType: 'token id_token',
        redirectUri: env.redirectUri
    },
    apiPath: env.audience + 'api/',
    googleMapKey: 'AIzaSyAcan1o2LUL06ZkPuDqk-qQMwwPDR_Yarc'
};